import { ScrollArea } from '@/components/ui/scroll-area';
import { AssignmentCard } from './AssignmentCard';
import type { AssignmentResponse } from '@/types';

export interface AssignmentListProps {
  assignments: AssignmentResponse[];
  expandedAssignments: Set<string>;
  onToggleExpanded: (assignmentId: string) => void;
}

export function AssignmentList({
  assignments,
  expandedAssignments,
  onToggleExpanded,
}: AssignmentListProps) {
  return (
    <ScrollArea className='h-full'>
      <div className='p-4'>
        <div className='space-y-4'>
          {assignments.map(assignment => (
            <AssignmentCard
              key={assignment.id}
              assignment={assignment}
              isExpanded={expandedAssignments.has(assignment.id)}
              onToggleExpanded={onToggleExpanded}
            />
          ))}
        </div>
      </div>
    </ScrollArea>
  );
}
